export default __webpack_public_path__ + "static/media/hipTransversalMovement.e8b6be68.png";